<template>
  <div>
    <BContainer fluid class="mt-3">
      <BRow>
        <BCol>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>ルート管理</h5>
            <div class="d-flex float-right">
            </div>
          </div>
        </BCol>
      </BRow>
      <BRow>
        <BCol class="col-md-3">
          <BOverlay :show="l_routelist_overlay" spinner-variant="primary" rounded="sm">
            <BOverlay :show="l_routelist_loading_overlay">
              <template #overlay>
                <div></div>
              </template>
              <BCard no-body class="shadow-sm">
                <template #header>
                  ルートリスト
                </template>
                <BFormGroup class="m-3">
                  <BInputGroup class="mt-1 w-100">
                    <template #prepend>
                      <BInputGroupText>企業</BInputGroupText>
                    </template>
                    <BFormSelect id="company-type" v-model="l_company_selected" :options="l_company_options"
                      @update:model-value="handlerSearchCompany"></BFormSelect>
                  </BInputGroup>

                  <BInputGroup class="mt-1 w-100">
                    <template #prepend>
                      <BInputGroupText>曜日</BInputGroupText>
                    </template>
                    <BFormSelect id="weekday-type" v-model="l_weekday_selected" :options="l_weekday_options"
                      :disabled="l_weekdayselection_disable" @update:model-value="handlerSearchWeekday"></BFormSelect>
                  </BInputGroup>
                </BFormGroup>

                <BListGroup flush>
                  <BListGroupItem v-for="(item, idx) in l_routeListJSON_filtered.data" :key="item.id + '-' + idx">
                    <div class="route-header d-flex justify-content-between align-items-center cursor-pointer"
                      @click="toggleAccordion(item.id)">
                      <div class="route-title d-flex align-items-center">
                        <span class="route-company-name" :style="getCompanyBadgeStyle(item.assigned.companyId)">
                          {{ item.assigned.companyName }}
                        </span>
                        <span class="route-weekday">{{ item.weekday?.weekdayJa }}</span>
                        <span v-if="isAreaNameVisible(item.assigned.companyId) && item.area" class="route-area">
                          {{ item.area }}
                        </span>
                      </div>
                      <h4 v-if="item.type == 'RecycleGarbage'">
                        <BBadge v-if="item.collection.collectionType == '設置'" variant="warning"
                          class="pointer-events-none">
                          <i class="bi bi-recycle"></i>
                        </BBadge>
                        <BBadge v-else variant="primary" class="pointer-events-none">
                          <i class="bi bi-recycle"></i>
                        </BBadge>
                      </h4>
                    </div>

                    <div v-if="isAccordionOpen(item.id)" :id="`routelist-accordion-${item.id}`" role="tabpanel">
                      <BCard>
                        <h6>ルートID : {{ item.id }}</h6>
                        <h6>企業名 : {{ item.assigned.companyName }}</h6>
                        <h6>ごみ種別 : {{ item.type_ja }}</h6>
                        <h6>曜日 : {{ item.weekday?.weekdayJa }}</h6>
                        <h6>{{ item.areaLabel }} : {{ item.area }}</h6>
                        <h6>ステーション(割当済) : {{ item.stations }}</h6>
                        <BCardText>
                          <h5>
                            <BBadge class="mr-2" v-for="data in item.company" :key="item.company.indexOf(data)"
                              variant="secondary">
                              {{ data.companyName }}
                            </BBadge>
                          </h5>
                        </BCardText>
                      </BCard>

                      <BButton @click="openDeleteModal(l_routeListJSON_filtered.data.indexOf(item))" class="mt-2 w-100"
                        variant="danger">
                        このルートを削除する
                      </BButton>

                      <BModal v-model="showDeleteModal" :title="'ルートの削除'" @show="l_routeDeleteCompleted = false" @hidden="currentItem = null">
                        <template #header>
                          <h5 class="deletemodal">ルートの削除</h5>
                        </template>

                        <p class="deletemodal">このルートを削除しますか？</p>
                        <BCard class="deletemodal" :title="currentItem ? 'ルートID : ' + currentItem.id : ''"
                          :sub-title="currentItem ? '企業名 : ' + currentItem.assigned?.companyName : ''">
                          <BCardText v-if="currentItem">
                            {{ currentItem.type_ja }}({{ currentItem.collection?.collectionType }})
                            <div>
                              /{{ currentItem.weekday?.weekdayJa }}
                            </div>
                          </BCardText>
                        </BCard>

                        <BButton :disabled="l_routeDeleteProcessing || l_routeDeleteCompleted" class="w-100 mt-2"
                          variant="danger" @click="deleteRouteDetaWrapper(currentItem?.id)">
                          <div v-if="!l_routeDeleteCompleted">
                            削除する
                            <BSpinner v-if="l_routeDeleteProcessing" label="Spinning" small class="ml-2" />
                          </div>
                          <div v-else>完了しました</div>
                        </BButton>

                        <template #footer>
                          <BButton v-if="!l_routeDeleteCompleted" :disabled="l_routeDeleteProcessing"
                            class="deletemodal" variant="secondary" @click="showDeleteModal = false">
                            いいえ(中止します)
                          </BButton>
                          <BButton v-else :disabled="l_routeDeleteProcessing" class="deletemodal" variant="secondary"
                            @click="showDeleteModal = false">
                            閉じる
                          </BButton>
                        </template>
                      </BModal>
                    </div>
                  </BListGroupItem>
                </BListGroup>
              </BCard>
            </BOverlay>
          </BOverlay>
        </BCol>
        <BCol>
          <BCard no-body class="shadow-sm">
            <RouteMapModule ref="routemapmodule" :handle-refresh-route="getRouteDataListWrapper" />
          </BCard>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import RouteMapModule from './../modules/RouteMapModule.vue'
export default {
  components: {
    RouteMapModule
  },
  data() {
    return {
      // companyMaster.dataNoごとのステーションアイコン(trash_household_*.png)と同色の背景色
      companyBadgeColorMapping: {
        "0": "#0070C0",
        "1": "#0070C0",
        "2": "#548235",
        "3": "#548235",
        "4": "#D23743",
        "5": "#D23743",
        "6": "#FFA500",
        "7": "#FFA500",
        "8": "#FFA500",
        "9": "#8000C0",
      },

      // GUI LocalVariables
      l_routelist_overlay: true,
      l_routelist_loading_overlay: false,
      l_weekdayselection_disable: true,

      l_company_selected: "",
      l_company_options: [],
      l_companyMasterList: [],
      l_routeListJSON_filtered: {
        data: []
      },
      l_routeListJSON: {
        data: []
      },
      l_routeIdList: [],
      l_selectedRouteData: {},
      l_selectedStationData: {},
      l_selecteGarbageType: 'HouseholdGarbage',
      l_weekday_selected: "",
      l_weekday_options: [],

      l_routeDeleteProcessing: false,
      l_routeDeleteCompleted: false,
      // Accordion state management
      activeAccordionId: null,
      currentModalId: null, // 現在表示中のモーダルID
      showDeleteModal: false, // モーダルの表示状態
      currentItem: null, // 現在選択されているアイテム
    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  async mounted() {
    // DOM更新とコンポーネント初期化の完了を待つ
    await this.$nextTick()

    // 曜日表示(n4Options)の解決に企業マスタが必要なので、ルート一覧取得前に待機する
    this.l_companyMasterList = await this.fetchCompanyMasterList()
    this.l_company_options = this.getCompanyOptions(this.l_companyMasterList)
    // ログインユーザーの企業を初期選択する(ダッシュボードと同じ挙動)
    this.l_company_selected = this.getDefaultCompanyFilterValue(
      this.$store.getters.userAttributes?.['custom:company'], this.l_company_options)

    this.getRouteDataListWrapper();
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    // Getter of ...
  },
  watch: {
  },
  methods: {
    getCompanyBadgeStyle(companyId) {
      return { backgroundColor: this.companyBadgeColorMapping[companyId] ?? "#6c757d" }
    },
    // エリア名は0:ミツワ(可燃)と2:エコリレー(可燃)のみ表示する
    isAreaNameVisible(companyId) {
      return ["0", "2"].includes(String(companyId))
    },
    // RouteMapModule refヘルパーメソッド
    safeRouteMapCall(methodName, ...args) {
      if (this.$refs.routemapmodule && this.$refs.routemapmodule[methodName]) {
        return this.$refs.routemapmodule[methodName](...args);
      } else {
        console.warn(`RouteMapModule method '${methodName}' not available`);
        return null;
      }
    },

    // Accordion control methods
    toggleAccordion(accordionId) {
      if (this.activeAccordionId === accordionId) {
        this.activeAccordionId = null; // Close if already open
      } else {
        this.activeAccordionId = accordionId; // Open new accordion
        // アコーディオンが開かれた際にルート詳細を読み込む
        const routeItem = this.l_routeListJSON_filtered.data.find(item => item.id === accordionId);
        if (routeItem) {
          const index = this.l_routeListJSON_filtered.data.indexOf(routeItem);
          this.handlerSelectRouteID(routeItem, index);
        }
      }
    },

    isAccordionOpen(accordionId) {
      return this.activeAccordionId === accordionId;
    },

    // Common Function ============================
    // GUI Handler ================================
    // Handler of Changing Company
    handlerSearchCompany(event) {
      // 企業変更に伴い曜日選択をリセット(ダッシュボードと同じ挿動)
      this.l_weekday_selected = ""
      this.startRouteFiltering()
    },
    // Handler of Changing Weekday
    handlerSearchWeekday(event) {
      this.startRouteFiltering()
    },
    // Handler of Route ID Selection
    handlerSelectRouteID: async function (data, index) {
      this.l_routelist_loading_overlay = true
      this.$refs.routemapmodule.enableLoadingFullScreenState()
      this.$refs.routemapmodule.hideCurrentRouteData();
      this.$refs.routemapmodule.hideCurrentStationData();
      await this.getRouteDetailDataWrapper(data, index)
      // Show Request to Map Module
      await this.$refs.routemapmodule.showRouteData(data.id, this.l_selectedRouteData, this.l_routeIdList);
      this.$refs.routemapmodule.showCurrentStationData(data.id, this.l_selectedStationData.features, this.l_selecteGarbageType, data.collection.collectionType);
      this.$refs.routemapmodule.disableLoadingFullScreenState()
      this.l_routelist_loading_overlay = false
    },
    // Start Route Filtering
    startRouteFiltering() {
      // 曜日フィルタの選択肢・有効無効は選択中企業に連動させる(ダッシュボードの曜日フィルタと同じ条件)
      this.l_weekday_options = this.buildCompanyDayOfWeekOptions(this.l_company_selected, this.l_companyMasterList)
      this.l_weekdayselection_disable = (this.l_company_selected == "")

      // 常に全種別を表示する
      var filtered = this.l_routeListJSON.data.filter(function (item, index) {
        if (this.l_company_selected == "") {
          // Weekday
          if (
            this.isCompanyDayOfWeekMatched(this.l_weekday_selected, item.assigned.companyId, item.weekday.n4, item.weekday.n5)
          ) return true;
        }
        else {
          // Company / Weekday
          if (
            item.assigned.companyId == this.l_company_selected &&
            this.isCompanyDayOfWeekMatched(this.l_weekday_selected, item.assigned.companyId, item.weekday.n4, item.weekday.n5)
          ) return true;
        }
      }.bind(this));
      this.l_routeListJSON_filtered.data = filtered
      this.l_company_options = this.getCompanyOptions(this.l_companyMasterList)

      let isSelected = false
      // $refs.routemapmoduleの安全なアクセス
      const selectedRouteId = this.$refs.routemapmodule ? this.$refs.routemapmodule.l_selectedRouteId : "";

      for (let i in filtered) {
        if (filtered[i].id == selectedRouteId) {
          isSelected = true
          break
        }
      }

      //Reset Map - $refsの存在チェックを追加
      if (!isSelected && selectedRouteId != "" && this.$refs.routemapmodule) {
        this.$refs.routemapmodule.l_selectedRouteId = ""
        this.$refs.routemapmodule.hideCurrentRouteData();
        this.$refs.routemapmodule.hideCurrentStationData();
        this.$refs.routemapmodule.hideHistoryRouteData();
      }

      // adjust scroll position after rendering
      this.$nextTick(function () {
        if (isSelected && selectedRouteId) {
          const selectedElement = document.querySelector("#routelist-accordion-" + selectedRouteId)
          if (selectedElement && selectedElement.parentNode) {
            selectedElement.parentNode.scrollIntoView()
          }
        } else {
          const listElement = document.querySelector(".list-group")
          if (listElement) {
            listElement.scrollTop = 0
          }
        }
      })
    },
    // Update Route Lists
    updateRouteLists(data) {
      var lists = [];
      for (var i in data) {
        var routeid = data[i].routeId

        // //函館市分割
        // var companyData = this.getCompanyFromId(routeid.substr(0, 1))
        // var collectionData = this.getCollectionTypeFromId(routeid.substr(3, 1), companyData)
        // if (companyData.companyId == "0") {
        //   var weekdayData = this.getWeekdayDataFromId(routeid.substr(1, 1), routeid.substr(2, 1), companyData.garbagetype, collectionData.collectionId)
        //   var carnumber=""
        // } else if (companyData.companyId == "1") {
        //   var weekdayData = ""
        //   var carnumber=routeid.substr(1, 2)
        // } else {
        //   var weekdayData = this.getWeekdayDataFromId(routeid.substr(1, 1), routeid.substr(2, 1), companyData.garbagetype, collectionData.collectionId)
        // }

        //春日部2nd実証ルートID仕様
        var companyNo = routeid.substr(0, 1)
        // 割当企業名はcompanyMaster(ミツワ・エコリレー等)の実データから解決する
        var companyMasterEntry = (this.l_companyMasterList ?? []).find(c => String(c.dataNo) == companyNo)
        var companyData = {
          companyId: companyNo,
          companyName: companyMasterEntry ? companyMasterEntry.company : "不明"
        }
        var collectionData = this.getCollectionTypeFromId("0", companyData)
        var carnumber = ""

        var n4 = routeid.substr(3, 1)
        var n5 = routeid.substr(4, 1)

        var garbagetype = (data[i].garbageType == "0") ? 'HouseholdGarbage' : 'RecycleGarbage'
        var garbagetype_ja = (data[i].garbageType == "0") ? '家庭ごみ' : '資源ごみ'

        var lastupdatets = data[i]['last-update'].replaceAll("/", "-")
        var lastact = moment.utc(lastupdatets).local().format('YYYY/MM/DD HH:mm:ss')

        var assigned = companyData
        var collection = collectionData
        // ダッシュボードの曜日フィルタと同じ文言(companyMaster.n4Options)で表示する
        var weekdayLabel = this.getRouteWeekdayLabel(companyNo, n4, n5, this.l_companyMasterList)
        var weekday = { weekdayJa: weekdayLabel, n4: n4, n5: n5 }
        // companyNo=5,9(週単位)は「週」、それ以外は「エリア」としてn5Optionsの文言を表示する
        var areaLabel = ["5", "9"].includes(companyNo) ? "週" : "エリア"
        var area = this.getRouteAreaLabel(companyNo, n5, this.l_companyMasterList)
        var jsondataname = data[i].jsonDataName
        var station = '-'
        var notassigned = '-'
        var trip = data[i].totalTrip

        var part = {
          id: routeid,
          type: garbagetype,
          type_ja: garbagetype_ja,
          trips: trip,
          lastact: lastact,
          assigned: assigned,
          collection: collection,
          weekday: weekday,
          areaLabel: areaLabel,
          area: area,
          stations: station,
          notassigned: notassigned,
          jsondataname: jsondataname,
          carnumber: carnumber
        }
        lists.push(part)
        this.l_routeIdList.push(routeid)
      }
      this.l_routeListJSON.data = lists
    },
    // Interface Wrapper
    getRouteDataListWrapper: async function () {
      this.l_routelist_overlay = true
      // $refs.routemapmoduleの存在確認
      if (this.$refs.routemapmodule && this.$refs.routemapmodule.enableLoadingFullScreenState) {
        this.$refs.routemapmodule.enableLoadingFullScreenState()
      }
      const vreqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          garbageType: "0",
          companyId: 0,
          dayWeek: 0,
          serach: ""
        }
      };

      await axios.get(this.createAPI("routemanagement/garbagerouterequest"), vreqdata)
        .then(response => {
          this.updateRouteLists(response.data.route)
          // $refsの存在チェック
          if (this.$refs.routemapmodule && this.$refs.routemapmodule.disableLoadingFullScreenState) {
            this.$refs.routemapmodule.disableLoadingFullScreenState()
          }
          this.l_routelist_overlay = false
        })
        .catch(error => {
          console.log("USE LOCAL DUMMY")
          console.log(error)

          // $refsの存在チェック
          if (this.$refs.routemapmodule && this.$refs.routemapmodule.disableLoadingFullScreenState) {
            this.$refs.routemapmodule.disableLoadingFullScreenState()
          }
          this.l_routelist_overlay = false
        })
      this.l_routeListJSON_filtered = JSON.parse(JSON.stringify(this.l_routeListJSON))
      this.startRouteFiltering()
    },
    getRouteDetailDataWrapper: async function (data, index) {
      var garbage = "0"
      if (data.type == "HouseholdGarbage") {
        garbage = "1"
      } else {
        garbage = "2"
      }
      const vreqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          routeid: data.id,
        }
      };
      //await axios.get(this.createAPI("routemanagement/garbagerouterequest"),vreqdata)
      await axios.get(this.createInternalAPI("route/detail"), vreqdata)
        .then(response => {
          var data = response.data;
          this.l_selecteGarbageType = (String(data.garbageType) == "0") ? 'HouseholdGarbage' : 'RecycleGarbage'
          var lonlat = []
          lonlat.push([Number(data.startPosition[0].longitude), Number(data.startPosition[0].latitude)])
          for (var j in data.waypoint) {
            lonlat.push([Number(data.waypoint[j].longitude), Number(data.waypoint[j].latitude)])
          }
          if (data.arrivalPosition.length > 0) {
            lonlat.push([Number(data.arrivalPosition[0].longitude), Number(data.arrivalPosition[0].latitude)])
          }

          this.l_selectedRouteData = {
            routedata:
            {
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  geometry: {
                    type: "LineString",
                    coordinates: lonlat
                  }
                }
              ]
            }
          }

          //CLAS-1283 this.l_routeListJSON_filtered.data[index].stations = data.stStatus.length
          var notassigned = (this.l_selecteGarbageType == "HouseholdGarbage") ? 6268 - data.stStatus.length : 1145 - data.stStatus.length

          this.l_routeListJSON_filtered.data[index].notassigned = notassigned
          var storeddata = this.$store.getters.stationDataIndex
          var features = [];
          var availableStations = 0 // CLAS-1283
          for (var i in data.stStatus) {
            // Additional Data
            var additionaldata = storeddata[data.stStatus[i].stationId]
            if (additionaldata == null) {
              console.log("ERROR:NOT FOUND STATION")
              console.log("ERROR:StationId", data.stStatus[i].stationId, " StationName:", data.stStatus[i].stName)
            } else {
              availableStations++ // CLAS-1283
              var latlon = additionaldata.location
              var lastupdatets = additionaldata.lastUpdated.replaceAll("/", "-")
              var lastUpdate = moment.utc(lastupdatets).local().format('YYYY/MM/DD HH:mm:ss')
              var part = {
                type: "Feature",
                properties: {
                  name: data.stStatus[i].stName,
                  id: data.stStatus[i].controlNumber,
                  type: (String(additionaldata.garbageType) == "0") ? 'HouseholdGarbage' : 'RecycleGarbage',
                  status: (String(additionaldata.collectStatus) == "0") ? 'Full' : 'Empty',
                  timestamp: lastUpdate,
                  today: false
                },
                geometry: {
                  type: "Point",
                  coordinates: latlon
                }
              }
              features.push(part)
            }
          }
          this.l_routeListJSON_filtered.data[index].stations = availableStations // CLAS-1283

          this.l_selectedStationData = {
            type: "FeatureCollection",
            features: features
          }
        })
        .catch(error => {
          console.log("USE LOCAL DUMMY")
          console.log(error)
        })
    },
    deleteRouteDetaWrapper(id) {
      this.l_routeDeleteProcessing = true

      const hdrdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
      };
      const paramdata = {
        routeId: id
      };
      axios.post(this.createAPI("routemanagement/routedeleterquest"), paramdata, hdrdata)
        .then(response => {
          this.l_routeDeleteProcessing = false
          this.l_routeDeleteCompleted = true
          // 修正 CLAS-1244
          this.l_routeIdList = this.l_routeIdList.filter(routeId => routeId != id)

          // reset Map
          this.$refs.routemapmodule.l_selectedRouteId = ""
          this.$refs.routemapmodule.hideHistoryRouteData();
          this.$refs.routemapmodule.hideHistoryStationData();

          this.$refs.routemapmodule.hideCurrentRouteData();
          this.$refs.routemapmodule.hideCurrentStationData();
          this.l_routelist_overlay = true
          this.getRouteDataListWrapper();
        })
        .catch(error => {
          this.l_routeDeleteProcessing = false
          this.l_routeDeleteCompleted = true

          this.$refs.routemapmodule.hideCurrentRouteData();
          this.$refs.routemapmodule.hideCurrentStationData();
          this.l_routelist_overlay = true
          this.getRouteDataListWrapper();
          console.log("ERROR")
          console.log(error)
        })
    },
    openDeleteModal(index) {
      this.currentModalId = index;
      this.currentItem = this.l_routeListJSON_filtered.data[index];
      this.showDeleteModal = true;
    }
  }
}
</script>
<style scoped>
.deletemodal {
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.list-group {
  height: calc(100vh - 21rem);
  overflow-y: auto;
  overflow-x: auto;
}

/* ウィンドウ幅が狭いときは行を縮めず、リスト側の横スクロールで全体を見られるようにする */
.route-header {
  min-width: max-content;
  gap: 0.5rem;
}

.route-title {
  gap: 0.5rem;
  font-size: 1rem;
  flex: 0 0 auto;
}

.route-company-name {
  flex: 0 0 9.5em;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  font-weight: 500;
  white-space: nowrap;
}

.route-weekday {
  flex: 0 0 4.5em;
  box-sizing: border-box;
  text-align: center;
  white-space: nowrap;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  background-color: #e9ecef;
}

.route-area {
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  background-color: #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px #777;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
  box-shadow: none;
}
</style>
